import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

export default function AdminDashboard() {
  
  const [totalRumah, setTotalRumah] = useState(0);
  const [menungguVerifikasi, setMenungguVerifikasi] = useState(0);
  const [iplLunas, setIplLunas] = useState(0);
  const [laporanBaru, setLaporanBaru] = useState(0);

  const [dashboard, setDashboard] = useState({
    totalRumah: 0,
    menungguVerifikasi: 0,
    iplLunas: 0
  });
  useEffect(() => {
    function updateDashboard(data) {

      setDashboard({
        totalRumah: data.totalRumah,
        menungguVerifikasi: data.menungguVerifikasi,
        iplLunas: data.iplLunas
      });
    
    }
    async function loadTotalRumah() {
      const { data, error } = await supabase
        .from("warga")
        .select("*");
  
      if (error) return;
  
      setTotalRumah(data.length);

      setDashboard(prev => ({
        ...prev,
        totalRumah: data.length
      }));
      
    }
  
    async function loadMenungguVerifikasi() {
      // support multiple possible status values from warga site (case variants)
      // Gunakan pagination karena default Supabase hanya 1000 record
      const PAGE_SIZE = 1000;
      let allData = [];
      let from = 0;
      let hasMore = true;
      let queryError = null;
      while (hasMore) {
        const { data, error } = await supabase
          .from("pembayaran")
          .select("*")
          .or("status.eq.Pending,status.eq.pending,status.eq.Menunggu,status.eq.menunggu,status.eq.PENDING,status.eq.MENUNGU")
          .range(from, from + PAGE_SIZE - 1);
        if (error) { queryError = error; break; }
        allData = allData.concat(data || []);
        hasMore = (data || []).length === PAGE_SIZE;
        from += PAGE_SIZE;
      }

      if (queryError) return;

      setMenungguVerifikasi(allData.length);
    }
  
    async function loadLaporanBaru() {

      const { data, error } = await supabase
  .from("laporan_warga")
  .select("*")
  .eq("status", "Menunggu");

if (error) return;

setLaporanBaru(data.length);
    
    }
  
    loadTotalRumah();
    loadMenungguVerifikasi();
    loadLaporanBaru();

    const kanal = supabase
      .channel("perubahan_pembayaran_admin")
      .on("postgres_changes", { event: "*", schema: "public", table: "pembayaran" }, (payload) => {
        console.log("[Realtime] perubahan_pembayaran_admin event:", payload);
        loadMenungguVerifikasi();
      })
      .subscribe();

    return () => {
      supabase.removeChannel(kanal);
    };
    
  }, []);
  const cardStyle = {
    background:"#fff",
    borderRadius:"12px",
    padding:"20px",
    boxShadow:"0 2px 10px rgba(0,0,0,.08)",
    textAlign:"center"
  };
  
  const iconStyle = {
    fontSize:"42px",
    marginBottom:"10px"
  };
  
  const titleStyle = {
    fontWeight:"bold",
    color:"#666"
  };
  
  const numberStyle = {
    fontSize:"34px",
    fontWeight:"bold",
    color:"#1E5631",
    marginTop:"12px"
  };
  
  return (

    <div>
  
      <h2
        style={{
          color:"#1E5631",
          marginBottom:"20px"
        }}
      >
        📊 Dashboard Admin
      </h2>
  
      <div
        style={{
          display:"grid",
          gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",
          gap:"18px"
        }}
      >
  
        <div style={cardStyle}>
          <div style={iconStyle}>🏠</div>
          <div style={titleStyle}>Total Rumah</div>
          <div style={numberStyle}>{dashboard.totalRumah}</div>
        </div>
  
        <div style={cardStyle}>
          <div style={iconStyle}>💰</div>
          <div style={titleStyle}>⏳ Menunggu Verifikasi</div>
<div style={numberStyle}>{menungguVerifikasi}</div>
        </div>
  
        
        <div style={cardStyle}>
        <div style={iconStyle}>📩</div>
<div style={titleStyle}>Laporan Baru</div>
<div style={numberStyle}>{laporanBaru}</div>
        </div>
  
      </div>
  
    </div>
  
  );
      }